export default {
  path: 'tournament/:tournamentId',
  props: true,
  components: {
    default: () =>
      import(
        /* webpackChunkName: "tournament-layout" */ '@/modules/tournament/TournamentLayout.vue'
      ),
    overlay: () =>
      import(
        /* webpackChunkName: "overlay-tournament-details" */ '@/modules/tournament/views/OverlayTournamentDetails'
      )
  },
  children: [
    {
      path: '',
      name: 'TournamentDetails'
    },
    {
      path: 'overview',
      name: 'TournamentDetailsOverview',
      meta: {
        defaultTab: 'overview'
      },
      component: () =>
        import(
          /* webpackChunkName: "tournament-details-overview" */ '@/modules/tournament/components/TournamentDetailsOverview'
        )
    },
    {
      path: 'rule',
      name: 'TournamentDetailsRule',
      props: true,
      meta: {
        defaultTab: 'rule'
      },
      component: () =>
        import(
          /* webpackChunkName: "tournament-details-rule" */ '@/modules/tournament/components/TournamentDetailsRule'
        )
    },
    {
      path: 'bracket',
      name: 'TournamentDetailsBracket',
      props: true,
      meta: {
        defaultTab: 'bracket'
      },
      component: () =>
        import(
          /* webpackChunkName: "tournament-details-bracket" */ '@/modules/tournament/components/TournamentDetailsBracket'
        )
    },
    {
      path: 'teams',
      name: 'TournamentDetailsTeams',
      props: true,
      meta: {
        defaultTab: 'players'
      },
      component: () =>
        import(
          /* webpackChunkName: "tournament-details-teams" */ '@/modules/tournament/components/TournamentDetailsTeams'
        )
    },
    {
      path: 'lfg',
      name: 'TournamentDetailsLFG',
      props: true,
      meta: {
        defaultTab: 'players'
      },
      component: () =>
        import(
          /* webpackChunkName: "tournament-details-lfg" */ '@/modules/tournament/components/TournamentDetailsLFG'
        )
    }
  ]
}
